import React from 'react';

import Pagination from '@material-ui/lab/Pagination';

const PaginationComponent = ({ count, page, onChangePage }) => {
  return (
    <Pagination
      count={count}
      page={page}
      color="secondary"
      onChange={onChangePage}
    />
  );
};

export default PaginationComponent;
